import React from "react";
import Layout from "../../components/Layout";
import Blocs from "./Blocs";

function LabelisationPage() {
  return (
    <React.Fragment>
      <Layout variant={true} title="Labelisation Finance Innovation">
        <Blocs />
      </Layout>
    </React.Fragment>
  );
}

export default LabelisationPage;
